import React from 'react'

export default function Album() {
  return (
    <div className="screen-container">
      Album
    </div>
  )
}
